import {
  FETCH_ALL_COURSES_REQUESTED,
  FETCH_ALL_COURSES_SUCCESSFUL,
  FETCH_ALL_COURSES_FAILED,
  FETCH_SUBCATEGORY_REQUESTED,
  FETCH_SUBCATEGORY_SUCCESSFUL,
  FETCH_SUBCATEGORY_FAILED,
  FETCH_COURSE_BY_ID_REQUESTED,
  FETCH_COURSE_BY_ID_SUCCESSFUL,
  FETCH_COURSE_BY_ID_FAILED,
  FETCH_SIMILAR_COURSES_REQUESTED,
  FETCH_SIMILAR_COURSES_SUCCESSFUL,
  FETCH_SIMILAR_COURSES_FAILED,
  UPLOAD_SNAPSHOT_REQUESTED,
  UPLOAD_SNAPSHOT_SUCCESSFUL,
  UPLOAD_SNAPSHOT_FAILED,
  FETCH_CATEGORIES_REQUESTED,
  FETCH_CATEGORIES_SUCCESSFUL,
  FETCH_CATEGORIES_FAILED,
  FETCH_SCHOOL_BUNDLES_REQUESTED,
  FETCH_SCHOOL_BUNDLES_SUCCESSFUL,
  FETCH_SCHOOL_BUNDLES_FAILED,
  FETCH_BUNDLE_BY_ID_REQUESTED,
  FETCH_BUNDLE_BY_ID_SUCCESSFUL,
  FETCH_BUNDLE_BY_ID_FAILED,
  FETCH_COURSE_VOUCHER_REQUESTED,
  FETCH_COURSE_VOUCHER_SUCCESSFUL,
  FETCH_COURSE_VOUCHER_FAILED,
  FETCH_BUNDLE_VOUCHER_REQUESTED,
  FETCH_BUNDLE_VOUCHER_SUCCESSFUL,
  FETCH_BUNDLE_VOUCHER_FAILED,
  REMOVE_VOUCHER,
  SET_SNAPSHOT_ERROR,
  SET_VERIFICATION_ERROR,
  SHOW_CLASS_KYC_MODAL,
  HIDE_CLASS_KYC_MODAL,
  VERIFY_USER_SELFIE_REQUESTED,
  VERIFY_USER_SELFIE_SUCCESSFUL,
  VERIFY_USER_SELFIE_FAILED,
  APPLY_COURSE_APT_COINS_REQUESTED,
  APPLY_COURSE_APT_COINS_SUCCESSFUL,
  APPLY_COURSE_APT_COINS_FAILED,
  APPLY_BUNDLE_APT_COINS_REQUESTED,
  APPLY_BUNDLE_APT_COINS_SUCCESSFUL,
  APPLY_BUNDLE_APT_COINS_FAILED,
  REMOVE_COINS,
  SET_DARK_MODE,
  GET_PAYMENT_CHANNELS_REQUESTED,
  GET_PAYMENT_CHANNELS_SUCCESSFUL,
  GET_PAYMENT_CHANNELS_FAILED,
  GET_PAYMENT_FEES_REQUESTED,
  GET_PAYMENT_FEES_SUCCESSFUL,
  GET_PAYMENT_FEES_FAILED,
  POST_PAYMENT_REQUESTED,
  POST_PAYMENT_SUCCESSFUL,
  POST_PAYMENT_FAILED,
  GET_TRANSACTION_REQUESTED,
  GET_TRANSACTION_SUCCESSFUL,
  GET_TRANSACTION_FAILED,
  FETCH_TRANSACTION_DETAILS_REQUESTED,
  FETCH_TRANSACTION_DETAILS_SUCCESSFUL,
  FETCH_TRANSACTION_DETAILS_FAILED,
} from "./action-types"

export const fetchAllCourses = (data, id, isLoggedIn) => {
  let queryStr = []
  queryStr = Object.values(data).join("&")

  return {
    types: [
      FETCH_ALL_COURSES_REQUESTED,
      FETCH_ALL_COURSES_SUCCESSFUL,
      FETCH_ALL_COURSES_FAILED,
    ],
    payload: {
      auth: isLoggedIn,
      request: {
        method: "GET",
        url: `/schools/${id}/courses/?${queryStr}`,
      },
    },
  }
}

export const fetchSubcategories = (id) => {
  return {
    types: [
      FETCH_SUBCATEGORY_REQUESTED,
      FETCH_SUBCATEGORY_SUCCESSFUL,
      FETCH_SUBCATEGORY_FAILED,
    ],
    payload: {
      request: {
        method: "GET",
        url: `/schools/${id}/subcategories/`,
        auth: false,
      },
    },
  }
}

export const fetchCategories = (id) => {
  return {
    types: [
      FETCH_CATEGORIES_REQUESTED,
      FETCH_CATEGORIES_SUCCESSFUL,
      FETCH_CATEGORIES_FAILED,
    ],
    payload: {
      request: {
        method: "GET",
        url: `/course/categories-list/`,
        auth: false,
      },
    },
  }
}

export const fetchCourseById = (id) => {
  return {
    types: [
      FETCH_COURSE_BY_ID_REQUESTED,
      FETCH_COURSE_BY_ID_SUCCESSFUL,
      FETCH_COURSE_BY_ID_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/courses/${id}/`,
      },
    },
  }
}

export const fetchSimilarCourses = (id) => {
  return {
    types: [
      FETCH_SIMILAR_COURSES_REQUESTED,
      FETCH_SIMILAR_COURSES_SUCCESSFUL,
      FETCH_SIMILAR_COURSES_FAILED,
    ],
    payload: {
      request: {
        method: "GET",
        url: `/courses/${id}/similar_courses/`,
        auth: false,
      },
    },
  }
}

export const uploadSnapshot = (data) => {
  return {
    types: [
      UPLOAD_SNAPSHOT_REQUESTED,
      UPLOAD_SNAPSHOT_SUCCESSFUL,
      UPLOAD_SNAPSHOT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `kyc/upload/snapshot/`,
        data,
      },
    },
  }
}

export const fetchAllBundles = (data, id, isLoggedIn) => {
  let queryStr = []
  queryStr = Object.values(data).join("&")

  return {
    types: [
      FETCH_SCHOOL_BUNDLES_REQUESTED,
      FETCH_SCHOOL_BUNDLES_SUCCESSFUL,
      FETCH_SCHOOL_BUNDLES_FAILED,
    ],
    payload: {
      auth: isLoggedIn,
      request: {
        method: "GET",
        url: `/schools/${id}/bundles/?${queryStr}`,
      },
    },
  }
}

export const fetchBundleById = (id) => {
  return {
    types: [
      FETCH_BUNDLE_BY_ID_REQUESTED,
      FETCH_BUNDLE_BY_ID_SUCCESSFUL,
      FETCH_BUNDLE_BY_ID_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/course/bundles/${id}/`,
      },
    },
  }
}

export const fetchCourseVoucher = (voucherCode, courseId) => {
  return {
    types: [
      FETCH_COURSE_VOUCHER_REQUESTED,
      FETCH_COURSE_VOUCHER_SUCCESSFUL,
      FETCH_COURSE_VOUCHER_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/vouchers/${voucherCode}/course/${courseId}/`,
      },
    },
  }
}

export const fetchBundleVoucher = (voucherCode, bundleId) => {
  return {
    types: [
      FETCH_BUNDLE_VOUCHER_REQUESTED,
      FETCH_BUNDLE_VOUCHER_SUCCESSFUL,
      FETCH_BUNDLE_VOUCHER_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/vouchers/${voucherCode}/bundle/${bundleId}/`,
      },
    },
  }
}

export const applyCourseAptCoins = (courseId, data) => {
  return {
    types: [
      APPLY_COURSE_APT_COINS_REQUESTED,
      APPLY_COURSE_APT_COINS_SUCCESSFUL,
      APPLY_COURSE_APT_COINS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/wallets/apply_coins/course/${courseId}/`,
        data,
      },
    },
  }
}

export const applyBundleAptCoins = (bundleId, data) => {
  return {
    types: [
      APPLY_BUNDLE_APT_COINS_REQUESTED,
      APPLY_BUNDLE_APT_COINS_SUCCESSFUL,
      APPLY_BUNDLE_APT_COINS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/wallets/apply_coins/bundle/${bundleId}/`,
        data,
      },
    },
  }
}

export const verifyUserSelfie = (data) => {
  return {
    types: [
      VERIFY_USER_SELFIE_REQUESTED,
      VERIFY_USER_SELFIE_SUCCESSFUL,
      VERIFY_USER_SELFIE_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/kyc/verify/selfie/`,
        data,
      },
    },
  }
}

export const removeVoucher = (payload) => {
  return {
    type: REMOVE_VOUCHER,
    payload,
  }
}

export const removeCoins = (payload) => {
  return {
    type: REMOVE_COINS,
    payload,
  }
}

export const setSnapshotError = (payload) => {
  return {
    type: SET_SNAPSHOT_ERROR,
    payload,
  }
}

export const setVerificationError = (payload) => {
  return {
    type: SET_VERIFICATION_ERROR,
    payload,
  }
}

export const showClassKYCModal = (payload) => {
  return {
    type: SHOW_CLASS_KYC_MODAL,
    payload,
  }
}

export const hideClassKYCModal = (payload) => {
  return {
    type: HIDE_CLASS_KYC_MODAL,
    payload,
  }
}

export const setLMSTheme = (payload) => {
  return {
    type: SET_DARK_MODE,
    payload,
  }
}

export const getPaymentChannels = (filters) => {
  const queryString = new URLSearchParams(filters).toString()

  return {
    types: [
      GET_PAYMENT_CHANNELS_REQUESTED,
      GET_PAYMENT_CHANNELS_SUCCESSFUL,
      GET_PAYMENT_CHANNELS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/payment/fetch_channels/?${queryString}`,
      },
    },
  }
}

export const getPaymentFees = (data) => {
  return {
    types: [
      GET_PAYMENT_FEES_REQUESTED,
      GET_PAYMENT_FEES_SUCCESSFUL,
      GET_PAYMENT_FEES_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/payment/fees/`,
        data,
      },
    },
  }
}

export const postPayment = (data) => {
  return {
    types: [
      POST_PAYMENT_REQUESTED,
      POST_PAYMENT_SUCCESSFUL,
      POST_PAYMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `payment/process/`,
        data,
      },
    },
  }
}

export const getTransactionDetails = (txn_id) => {
  return {
    types: [
      GET_TRANSACTION_REQUESTED,
      GET_TRANSACTION_SUCCESSFUL,
      GET_TRANSACTION_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/payment/bux/fetch_details/?txn_id=${txn_id}`,
      },
    },
  }
}

export const fetchTransactionDetails = (txId) => {
  return {
    types: [
      FETCH_TRANSACTION_DETAILS_REQUESTED,
      FETCH_TRANSACTION_DETAILS_SUCCESSFUL,
      FETCH_TRANSACTION_DETAILS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/transaction/${txId}/`,
      },
    },
  }
}
